module.exports = __webpack_public_path__ + "static/media/ot-dest.8186da9e.svg";